import { useState, useEffect, Fragment, useRef } from "react";
import { useFormikContext } from "formik";
import { Grid } from "@mui/material";

import Field from "../../../utils/FormikFields/Field";
import { InputLabel } from "../../../utils/Common";

import { DateTime } from "luxon";

const SelectDueDate = () => {

  const { values, setFieldValue } = useFormikContext() || {};

  let repairs = values?.repairs || [];

  useEffect(() => {
    if (values?.repair_ticket_id) {
      setFieldValue("due_date", values?.due_date)
      return;
    }; // skip if we are editing a ticket

    if (!repairs.length) return;
    let totalTime = repairs.reduce((total, repair) => total + repair.estimated_time_to_complete, 0)
    let eta = DateTime.local().plus({days: totalTime})
    setFieldValue("due_date", eta)
  }, [values?.repair_ticket_id, repairs])

  return (
    <Fragment>
      <Grid size={{xs: 12}}>
        <InputLabel>Due Date</InputLabel>
        <Field formFieldType="date" name="due_date" type="date" />
      </Grid>
    </Fragment>
  )
};

export default SelectDueDate;